import { Button, Card, CardContent } from "@deere/fuel-react";
import { Box } from "@mui/material";
import React, { useState } from "react";
import Field from "../../common/field";
import { useTranslation } from "../../common/translation-context";
import { ROLES } from "../../constants/constant";
import { getUserRole } from "../../utils/utils";
import { useSelector } from "react-redux";

export default function Search(props) {
  const [isDisabled, setIsDisabled] = useState(sessionStorage.length === 0);
  const [isDisabledSearchFilter, setIsDisabledSearchFilter] = useState(false);
  const [isDisabledDropdownFilter, setIsDisabledDropdownFilter] =
    useState(false);
  const [resetKey, setResetKey] = useState(0);

  const { translate: t } = useTranslation();
  const userData = useSelector((state) => state.userState.userData);
  const [requestStatuss, setRequestStatuss] = useState([]);

  const selectedExtensionType = (value) => {
    setIsDisabled(false);
    props.onExtensionChange(value);
  };

  const selectRequestStatus = (value) => {
    setIsDisabledSearchFilter(true);
    setIsDisabled(false);
    setRequestStatuss(value || []);
    props.onRequestStatusChange(value);
  };

  const selectedCountryMulti = (value) => {
    setIsDisabledSearchFilter(true);
    setIsDisabled(false);
    props.onCountryChange(value);
  };

  const clearAllFeilds = () => {
    setIsDisabled(true);
    setIsDisabledSearchFilter(false);
    setIsDisabledDropdownFilter(false);
    setRequestStatuss([]);
    setResetKey((prev) => prev + 1);

    if (props.view === "logs") {
      if (props.onRequestStatusChange) {
        props.onRequestStatusChange([]);
      }
      if (props.onCountryChange) {
        props.onCountryChange([]);
      }
      if (props.setAssignmentNo) {
        props.setAssignmentNo("");
      }
      if (props.onChangeSerialNo) {
        props.onChangeSerialNo("");
      }
      if (props.setDateRange) {
        props.setDateRange([null, null]);
      }
      if (props.onClearFilters) {
        props.onClearFilters();
      }
    }
  };

  const setAssignmentNo = (value) => {
    setIsDisabledDropdownFilter(value.length > 0);
    setIsDisabled(false);
    const trimmed = (value ?? "").trim();
    props.setAssignmentNo(trimmed);
  };
  const setSerialtNo = (value) => {
    setIsDisabledDropdownFilter(value.length > 0);
    setIsDisabled(false);
    const trimmed = (value ?? "").trim();
    props.onChangeSerialNo(trimmed);
  };

  const setDateRange = (value) => {
    setIsDisabledSearchFilter(true);
    setIsDisabled(false);
    props.setDateRange(value);
  };

  return (
    <div>
      <Box>
        <Card>
          <CardContent>
            <h3>{t("filters")}</h3>
            <div className="action-area">
              {props.view === "logs" ? (
                <Field
                  key={`serial-${resetKey}`}
                  disabled={isDisabledSearchFilter}
                  onChange={setSerialtNo}
                  label="Search by Serial No"
                  type={"search"}
                />
              ) : null}
              {props.view === "logs" ? (
                <Field
                  key={`assignment-${resetKey}`}
                  disabled={isDisabledSearchFilter}
                  onChange={setAssignmentNo}
                  label="Search by Assignment No"
                  type={"search"}
                />
              ) : null}
              {props.view === "logs" ? (
                <Field
                  key={`requestStatus-${resetKey}`}
                  options={props.requestStatus}
                  disabled={isDisabledDropdownFilter}
                  onMultiChange={selectRequestStatus}
                  value={requestStatuss}
                  label="Request Status"
                  type={"multiSelect"}
                />
              ) : null}

              {getUserRole(userData) !== ROLES.CCM && (
                <Field
                  key={`country-${resetKey}`}
                  disabled={isDisabledDropdownFilter}
                  onMultiChange={selectedCountryMulti}
                  label="Country"
                  type={"multiSelect"}
                  options={props.listOfCountries}
                  value={props.selectedCountry}
                />
              )}

              {props.view !== "logs" ? (
                <Field
                  key={`extensionType-${resetKey}`}
                  onChange={selectedExtensionType}
                  label="Extension Type"
                  type={"select"}
                  options={props.extensionTypes}
                  value={props.selectedExtension}
                />
              ) : null}

              {/* Date-range */}
              {props.view === "logs" ? (
                <Field
                  key={`dateRange-${resetKey}`}
                  disabled={isDisabledDropdownFilter}
                  onChange={setDateRange}
                  label="Search by Date Range"
                  type={"search-date"}
                />
              ) : null}

              <Button
                disabled={isDisabled ? true : false}
                variant="secondary"
                onClick={() => {
                  clearAllFeilds();
                }}
              >
                {t("clear")}
              </Button>
              {props.searchButton && (
                <Button variant="primary" onClick={() => props.onClickSearch()}>
                  {t("search")}
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
}
